// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_kb","wrapper__moderating":"_kc","text":"_kd","wrapper__declined":"_ke","icon":"_kf","icon__moderating":"_kg","icon__declined":"_kh"};